<template>
  <div id="filter-scroll-to">
    <div class="header-container">
      <div class="nav-wrapper container">
        <div class="nav-logo-wrapper">
          <router-link tag="a" class="nav-logo-content" to="/">
            <img
              class="logo-image"
              alt="logo"
              :src="logoData.image"
            />
            <div class="logo-text-wrapper" v-if="logoData.title">
              <span v-for="(item, i) in logoData.title.split(' ')" :key="i">{{
                item
              }}</span>
            </div>
          </router-link>
        </div>
        <div class="nav-mid-content">
          <button
            @click="goToFavorite"
            class="rounded-btn white selected-link-container"
          >
            <span class="hart-container">
              <span class="hart-icon">
                <IconBase height="16" width="16"><Heart /></IconBase>
              </span>
              <span class="selected-counter">{{ favoriteFlats.length }}</span>
            </span>
            <span class="selected-text">Обрані об’єкти</span>
          </button>
          <router-link
            tag="button"
            to="/add-advertisement"
            class="rounded-btn blue add-advertisement-link"
          >
            <span class="add-advertisement-text">Подати оголошення</span>
            <span class="add-advertisement-icon">
              <IconBase height="10" width="10"><Plus /></IconBase>
            </span>
          </router-link>
        </div>
        <div class="nav-end-content">
          <router-link :to="{ name: 'about-us' }" class="about-us">
            Про нас
          </router-link>
          <div class="currency-wrapper">
            <el-select
              v-model="value"
              size="mini"
              popper-class="language-select"
              @change="$store.dispatch('setGlobalCurrency', $event)"
            >
              <el-option
                v-for="item in currencyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="logIn-wrapper">
            <button
              class="logIn-btn"
              type="button"
              @click="!getUserToken ? (logInDialog = true) : logOutUser()"
            >
              <span class="logIn-Icon-container">
                <IconBase
                  v-if="!getUserToken || !meInfo.phone"
                  height="16"
                  width="16"
                  ><FaceIcon
                /></IconBase>
                <IconBase v-else height="16" width="16"><LogOut /></IconBase>
              </span>
              <span
                :class="{ active: !getUserToken || !meInfo.phone }"
                class="logIn-text enter"
                >Увійти</span
              >
              <span
                :class="{ active: getUserToken && meInfo.phone }"
                class="logIn-text quit"
                >Вийти</span
              >
            </button>
          </div>
        </div>
      </div>

      <!--      LogIn/Registration modal-->
      <el-dialog
        :visible.sync="logInDialog"
        width="110rem"
        custom-class="logIn-popUp"
        class="dialog-mobiel-version"
      >
        <LogInPopUp
          @close="logInDialog = false"
          @code-confirm="codeConfirmDialog = true"
          @forgot-password="forgotPasswordDialog = true"
        />
      </el-dialog>
      <el-dialog
        :visible.sync="codeConfirmDialog"
        width="50rem"
        class="desk-dialog-registration"
      >
        <CodeConfirmPopUp @close="codeConfirmDialog = false" />
      </el-dialog>

      <el-dialog
        :visible.sync="codeConfirmDialog"
        width="31rem"
        class="mobile-dialog-registration"
      >
        <CodeConfirmPopUp @close="codeConfirmDialog = false" />
      </el-dialog>

      <el-dialog
        custom-class="forgotPassword-popUp"
        :visible.sync="forgotPasswordDialog"
        class=""
      >
        <ForgotPassword
          @close="forgotPasswordDialog = false"
          @go-back="goBackFromForgotModal"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import IconBase from '@/components/icons/IconBase'
import Heart from '@/components/icons/Heart'
import Plus from '@/components/icons/Plus'
import FaceIcon from '@/components/icons/FaceIcon'
import LogInPopUp from '@/components/common/PopUps/LogInPopUp'
import CodeConfirmPopUp from '@/components/common/PopUps/CodeConfirmPopUp'
import { mapGetters } from 'vuex'
import ForgotPassword from '@/components/common/PopUps/ForgotPasswordPopUp'
import LogOut from '@/components/icons/LogOut'
import { host } from '@/services/config'

export default {
  name: 'Header',
  components: {
    LogOut,
    ForgotPassword,
    CodeConfirmPopUp,
    LogInPopUp,
    FaceIcon,
    IconBase,
    Heart,
    Plus,
  },
  computed: {
    ...mapGetters({
      currency: 'getGlobalCurrency',
      meInfo: 'getUserInfo',
      favoriteFlats: 'getFavoriteFlatList',
      logoData: 'getLogoData',
    }),

    currencyOptions() {
      return this.options.filter((item) => item.value !== this.currency)
    },
    logInDialog: {
      get: function () {
        return this.$store.getters.getLoginModalVisibility
      },
      set: function (newValue) {
        this.$store.commit('setLoginModalVisibility', newValue)
      },
    },
  },
  data() {
    return {
      logIn: true,
      get getUserToken() {
        return localStorage.getItem('token')
      },
      options: [
        {
          value: 'usd',
          label: '$ USD',
        },
        {
          value: 'uah',
          label: '₴ UAH',
        },
      ],
      value: '$ USD',
      codeConfirmDialog: false,
      forgotPasswordDialog: false,
      baseURL: host,
    }
  },
  methods: {
    goToFavorite() {
      this.$router.push({ name: 'favorite' })
    },
    goBackFromForgotModal() {
      this.forgotPasswordDialog = false
      setTimeout(() => (this.logInDialog = true), 300)
    },
    async logOutUser() {
      try {
        await this.$store.dispatch('logOutUser')
        location.reload()
      } catch (e) {
        this.$errorMessage('Упс... Щось пішло не так')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mobile-dialog-registration {
  display: none;
}
@media (max-width: 500px) {
  .mobile-dialog-registration {
    display: block;
  }
  .desk-dialog-registration {
    display: none;
  }
}
</style>
